import React, { lazy } from "react";
import { IDraftsProps } from "./definitions";

const LazyDrafts = lazy(() => import("./Drafts"));

const Drafts = (props: IDraftsProps) => <LazyDrafts {...props} />;

export default Drafts;
